import { PylotFrontendConfig, ModelTypeEnum } from 'config'
import { deepValue } from '@corratech/pylot-utils'
import type { ModelUrlConfig } from '@preload/graphql/getConfig.d'

export const resolvePageData = (
    path: string,
    customPages: PylotFrontendConfig['seo']['customPages'],
    urlConfig: ModelUrlConfig
): {
    pageType?: string
    pageName?: string
} => {
    if (path === '') {
        return {
            pageType: 'home',
            pageName: 'Home'
        }
    }
    // Intercept cases when it is a model route.
    // Page name there is the same as the page title
    for (const modelType of Object.values(ModelTypeEnum)) {
        const modelDirectory = urlConfig[modelType]?.directory
        if (modelDirectory && path.startsWith(modelDirectory)) {
            return {
                pageType: modelType,
                pageName: document?.querySelector('title')?.innerText
            }
        }
    }

    // In customPages sub-routes are under 'children' nodes of their parents
    const customPagesValuePath = path.replace(/\//g, '/children/').split('/')
    const { pageType = '', pageName = '' } = deepValue(
        customPages,
        customPagesValuePath,
        {}
    )

    return { pageType, pageName }
}
